export const navigation = [{
  name: '首页',
  path: '/'
}, {
  name: '产品服务',
  children: [{
    name: 'GUP裸金属服务器',
    path: '/service/gpu-metal'
  }, {
    name: 'GUP云服务器(即将推出)',
    path: ''
  }, {
    name: 'AI训练平台(即将推出)',
    path: ''
  }]
}, {
  name: '解决方案',
  children: [{
    name: '云游戏解决方案',
    path: '/scheme/game'
  }, {
    name: '云渲染决方案',
    path: '/scheme/render'
  }, {
    name: 'AI训练解决方案',
    path: '/scheme/train'
  }]
}, {
  name: '服务支持',
  path: '/afterSales'
}, {
  name: '关于我们',
  path: '/aboutUs'
}];
